module.exports = __webpack_public_path__ + "res/Roboto-Thin-webfont.woff?c29052a6c64bf87aae0ed5dbf303f083";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Thin-webfont.woff
// module id = 53
// module chunks = 0